import { render } from "./conversation-page.vue?vue&type=template&id=46654d24"
import script from "./conversation-page.js?vue&type=script&lang=js"
export * from "./conversation-page.js?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__